import React, { useState } from "react";
import styled from "styled-components";
import { Divider, Form } from "antd";
import { RAButtonPrimary, RARadioButton, RATypography } from "@/components/customs";
import { formatPhoneNumberStr } from "@/utils";

const SendOTPTemplate = ({ onFinish, email, phone, loading }) => {
	const [selected, setSelected] = useState("phone"); // phone - email
	return (
		<Container>
			<Form fields={[{ name: "email" }, { name: "password" }]} layout="vertical" className="form-login-wrapper">
				<FormInputWrapper>
					<TitleText>Additional protection</TitleText>
					<SubTitleForgotPassword>
						To protect your account, we are asking you to authenticate your identity. Please select an
						authentication method below.
					</SubTitleForgotPassword>
					<Divider />
					<WrapperItemSection>
						<RARadioButton
							checked={selected === "phone" ? true : false}
							onChange={() => setSelected("phone")}
						/>
						<div>
							<div>
								<RATypography variant="heading4">Phone</RATypography>
							</div>
							<div>
								<RATypography variant="body3">
									{phone ? formatPhoneNumberStr(phone) : "xxx xxx xxxx xxx"}
								</RATypography>
							</div>
						</div>
					</WrapperItemSection>
					<WrapperItemSection marginTop="20px">
						<RARadioButton
							checked={selected === "email" ? true : false}
							onChange={() => setSelected("email")}
						/>
						<div>
							<div>
								<RATypography variant="heading4">Email</RATypography>
							</div>
							<div>
								<RATypography variant="body3">{email || "unknown"}</RATypography>
							</div>
						</div>
					</WrapperItemSection>
					<WrapperBottom justify="center">
						<RAButtonPrimary
							onClick={() => onFinish(selected)}
							title="CONFIRM"
							width="180px"
							loading={loading}
						/>
					</WrapperBottom>
				</FormInputWrapper>
			</Form>
		</Container>
	);
};

const Container = styled.div``;
const FormInputWrapper = styled.div`
	align-self: center;
`;
const TitleText = styled.div`
	font-family: "Gilda Display";
	font-style: normal;
	font-weight: 400;
	font-size: 24px;
	line-height: 28px;
	text-transform: capitalize;
	color: #121216;
	margin-bottom: 20px;
	padding-left: 20px;
	border-left: 2px solid #ffb11a;
`;
const WrapperBottom = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 40px;
	gap: 12px;
`;
const SubTitleForgotPassword = styled.div`
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 22px;
	color: #595959;
`;
const WrapperItemSection = styled.div`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	padding: 10px 20px;
	border: 1px solid #e9e8e8;
	border-radius: 8px;
	margin-top: ${(props) => props.marginTop || "0px"};
`;

export default SendOTPTemplate;
